/* eslint-disable */
export default {
  dialer: 'Näppäimistö',
  allCalls: 'Kaikki puhelut',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
